

















































































































































import { Component, Vue } from 'vue-property-decorator';
import { RightEnum, TimeAccountSummaryModel, TimeAccountUserViewModel, TimeAccountYearViewModel } from '@/services/api/nswag/stapiclient_generated';
import { stAppUserApi, stTimeAccountApi } from '@/services/st-api';
import { DateTime } from 'luxon';
import StBadge from '@/components/basic/StBadge.vue';
import { UserStore } from '@/store/user-module';
import UserSelect from '@/views/TimeEntries/UserSelect.vue';
import TimeAccountDayCell from '@/views/TimeAccount/TimeAccountDayCell.vue';
import TimeAccountSumCell from '@/views/TimeAccount/TimeAccountSumCell.vue';
import { TimeEntryStore } from "@/store/time-entry-store";

@Component({
  components: {
    TimeAccountSumCell,
    TimeAccountDayCell,
    UserSelect,
    StBadge,
  },
})
export default class TimeAccount extends Vue {
  year: number = DateTime.local().year;
  loading = true;
  delayLoading = false;
  delayLoadingSummary = false;
  delayLoadingAppUser = false;

  yearlyModel: TimeAccountYearViewModel = TimeAccountYearViewModel.fromJS({});
  summaryModel: TimeAccountSummaryModel = TimeAccountSummaryModel.fromJS({ balanceOverall: {} });
  appUserModel: TimeAccountUserViewModel = TimeAccountUserViewModel.fromJS({});

  displayDetails: boolean = UserStore.currentUser?.timeAccountDisplayDetails ?? false;

  get selectedUserId(){
    return TimeEntryStore.selectedUserId;
  }

  set selectedUserId(data: number){
    TimeEntryStore.SetSelectedUserId(data);
  }

  get canManageTimeAdjustmentEnumValue(): RightEnum {
    return RightEnum.CanManageTimeAdjustment;
  }

  async beforeRouteUpdate(to: any, from: any, next: any) {
    next();
    if (to.name == 'TimeAccount') {
      try {
        await this.loadDataDelayLoading();
      } finally {
      }
    }
  }

  get currentYear() {
    return DateTime.utc().year;
  }

  addAdjustment(date: string) {
    this.$router.push({
      name: 'TimeAdjustmentEdit',
      params: { id: '0' },
      query: { date: date, appUserId: this.selectedUserId.toString() },
    });
  }

  editAdjustment(id: number) {
    this.$router.push({ name: 'TimeAdjustmentEdit', params: { id: id.toString() } });
  }

  async changeYear(plusminus: number) {
    try {
      this.loading = true;
      this.year += plusminus;
      await this.loadData();
    } finally {
      this.loading = false;
    }
  }

  async mounted() {
    try {
      this.loading = true;
      if(!this.selectedUserId){
        this.selectedUserId = UserStore.currentUser.id ?? 0;
      }
      await this.loadData();
    } finally {
      this.loading = false;
    }
  }

  loadDataDelayLoading() {
    this.loadSummaryDelayLoading();
    this.loadYearlyDelayLoading();
    this.loadAppUserDelayLoading();
  }

  async loadSummaryDelayLoading() {
    try {
      this.delayLoadingSummary = true;
      this.summaryModel = await stTimeAccountApi.getTimeAccountSummary(this.year, this.selectedUserId);
    } finally {
      this.delayLoadingSummary = false;
    }
  }

  async loadAppUserDelayLoading() {
    try {
      this.delayLoadingAppUser = true;
      this.appUserModel = await stTimeAccountApi.getTimeAccountUserViewModel(this.selectedUserId);
    } finally {
      this.delayLoadingAppUser = false;
    }
  }

  async loadYearlyDelayLoading() {
    try {
      this.delayLoading = true;
      this.yearlyModel = await stTimeAccountApi.getTimeAccount(this.year, this.selectedUserId);
    } finally {
      this.delayLoading = false;
    }
  }

  async loadData() {
    this.yearlyModel = await stTimeAccountApi.getTimeAccount(this.year, this.selectedUserId);
    this.summaryModel = await stTimeAccountApi.getTimeAccountSummary(this.year, this.selectedUserId);
    this.appUserModel = await stTimeAccountApi.getTimeAccountUserViewModel(this.selectedUserId);
  }

  async storeTimeAccountDisplayDetails() {
    await stAppUserApi.storeTimeAccountDisplayDetails(this.displayDetails);
    UserStore.reloadStore();
  }
}
